export function getDefaultAudience() {
  return process.env.AUTH0_DEFAULT_AUDIENCE || 'paintscout.com'
}
